'use client';

import { useLegalTerms } from '@/providers/legalTerms';

const boolean = new Map();
boolean.set(true, 'true');
boolean.set(false, 'false');

const ServiceTermsHidden = () => {
  const { termsOfServiceAccepted } = useLegalTerms();

  const value = boolean.get(termsOfServiceAccepted);

  return (
    <input type="hidden" name="terms-of-service-accepted" value={value}></input>
  );
};

export default ServiceTermsHidden;
